import {
    ProgramField,
    ProgramTemplatesType,
} from '../../redux/slices/programSlice'
import { isEmptyValue } from '../../utils/AttributeUtils'
import { IListItemValue } from '../../interfaces/Interfaces'

export interface OrgFieldDiff {
    addedIds: Set<string>
    addedOrgs: IListItemValue[]
    removedOrgs: IListItemValue[]
}

// Single source of truth for "what changed vs baseline" — used both by OrgPickerModal (its own
// Added/Removed summary panel) and ProgramInstance (the compact field's +N/-N badge), so the two
// can never disagree on what counts as added/removed.
export const diffOrgSelection = (
    baseline: IListItemValue[],
    selected: IListItemValue[],
): OrgFieldDiff => {
    const addedOrgs = selected.filter(
        (s) => !baseline.some((b) => b.id === s.id),
    )
    const removedOrgs = baseline.filter(
        (b) => !selected.some((s) => s.id === b.id),
    )
    return {
        addedIds: new Set(addedOrgs.map((o) => o.id)),
        addedOrgs,
        removedOrgs,
    }
}

interface ValidateProgramFieldsReturn {
    success: boolean
    programFields: ProgramField[]
    programTemplates: ProgramTemplatesType[]
}

export const validateProgramInstance = (
    fields: ProgramField[],
    programTemplates: ProgramTemplatesType[],
): ValidateProgramFieldsReturn => {
    let success = true
    const programFields = fields?.map((item: any) => {
        if (item.required && isEmptyValue(item.value)) {
            success = false
            return { ...item, errorMessage: 'This field is required' }
        } else {
            return item
        }
    })
    const updatedProgramTemplates = programTemplates.map((item) => ({
        ...item,
        categoryTemplates: item.categoryTemplates.map((i) => ({
            ...i,
            templates: i.templates.map((t) => {
                if (t.required && (i.selectedTemplates?.length ?? 0) < 1) {
                    success = false
                    return { ...t, errorMessage: 'This is required' }
                }
                return t
            }),
        })),
    }))

    return { success, programFields, programTemplates: updatedProgramTemplates }
}
